import { Box, Flex, Text, useTheme } from '@chakra-ui/react';
import { components } from 'chakra-react-select';
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';

export const TeamHierarchySelectOption = ({ children, ...props }: any) => {
  const { colors } = useTheme();

  const expandedTeamPaths: Set<string> =
    (props.selectProps as any)?.expandedTeamPaths ?? new Set();
  const toggleTeamExpand: (path: string) => void =
    (props.selectProps as any)?.toggleTeamExpand ?? (() => undefined);

  const depth: number = props.data?.depth ?? 0;
  const hasNestedSubTeams: boolean = props.data?.hasNestedSubTeams ?? false;
  const teamPath: string = props.data?.teamPath ?? '';
  const isExpanded = expandedTeamPaths.has(teamPath);
  const isSelected: boolean = props.isSelected;

  return (
    <components.Option
      {...props}
      innerProps={{
        ...props.innerProps,
        style: {
          ...props.innerProps?.style,
          backgroundColor: isSelected ? '#4d4dff' : 'transparent',
          color: isSelected ? 'white' : 'inherit',
          cursor: 'pointer',
        },
        onMouseEnter: (e: any) => {
          if (!isSelected) e.currentTarget.style.backgroundColor = '#F6F7F9';
          props.innerProps?.onMouseEnter?.(e);
        },
        onMouseLeave: (e: any) => {
          if (!isSelected)
            e.currentTarget.style.backgroundColor = 'transparent';
          props.innerProps?.onMouseLeave?.(e);
        },
      }}
    >
      <Flex
        align="center"
        gap={2}
        w="100%"
        color={isSelected ? 'white' : 'inherit'}
      >
        {hasNestedSubTeams ? (
          <Box
            as="button"
            onClick={(e: any) => {
              e.stopPropagation();
              e.preventDefault();
              toggleTeamExpand(teamPath);
            }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="16px"
            height="16px"
            flexShrink={0}
            _hover={{ bg: isSelected ? 'gray.600' : 'gray.100' }}
            borderRadius="sm"
          >
            {isExpanded ? (
              <AiOutlineMinus
                size={12}
                color={isSelected ? 'white' : colors.text.secondary}
              />
            ) : (
              <AiOutlinePlus
                size={12}
                color={isSelected ? 'white' : colors.text.secondary}
              />
            )}
          </Box>
        ) : (
          depth > 0 && <Box width="16px" flexShrink={0} />
        )}
        <Text
          as="span"
          fontWeight={depth === 0 ? 'normal' : 'light'}
          fontSize="14px"
          flex={1}
          noOfLines={1}
        >
          {children}
        </Text>
      </Flex>
    </components.Option>
  );
};
